import { OnInit, ChangeDetectorRef, ElementRef } from '@angular/core';
import { UsersService } from 'src/app/modules/shared/services/users.service';
import { Constants } from 'src/app/modules/shared/config/constants.config';
import { ThemeService } from '../../../shared/services/theme.service';
import { AppLoadingEventsEmitter } from '../../../shared/events/loading.events';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../../shared/services/auth.service';
import { MasterService } from '../../../shared/services/master.service';
import { DiaryService } from '../../../shared/services/diary.service';
import { forkJoin } from 'rxjs';
import * as moment from 'moment';
var NutrientsComponent = /** @class */ (function () {
    function NutrientsComponent(usersService, changeDetectorRef, themeService, constants, router, route, masterService, diaryService, appLoadingEventsEmitter, authService) {
        this.usersService = usersService;
        this.changeDetectorRef = changeDetectorRef;
        this.themeService = themeService;
        this.constants = constants;
        this.router = router;
        this.route = route;
        this.masterService = masterService;
        this.diaryService = diaryService;
        this.appLoadingEventsEmitter = appLoadingEventsEmitter;
        this.authService = authService;
        this.fromDate = this.getMonday(new Date());
        this.toDate = new Date((new Date()).setDate((new Date()).getDate() - (new Date()).getDay() + (((new Date()).getDay() === 0 ? -6 : 1)) + 6));
        this.settings = {
            bigBanner: false,
            timePicker: false,
            format: 'dd.MM.yyyy',
            defaultOpen: false,
            closeOnSelect: true
        };
    }
    NutrientsComponent.prototype.onStartDateChange = function (event) {
        var fromDate = moment(this.fromDate).format('YYYY-MM-DD');
        var toDate = moment(this.toDate).format('YYYY-MM-DD');
        if (fromDate > toDate) {
            this.toDate = this.fromDate;
            this.changeDetectorRef.detectChanges();
        }
        this.init();
    };
    NutrientsComponent.prototype.onToDateChange = function (event) {
        var fromDate = moment(this.fromDate).format('YYYY-MM-DD');
        var toDate = moment(this.toDate).format('YYYY-MM-DD');
        if (fromDate > toDate) {
            this.fromDate = this.toDate;
            this.changeDetectorRef.detectChanges();
        }
        this.init();
    };
    NutrientsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params.subscribe(function (params) {
            _this.userId = params['id'];
            _this.init();
        });
    };
    NutrientsComponent.prototype.init = function () {
        var _this = this;
        this.appLoadingEventsEmitter.broadcastAppIsLoading(true);
        forkJoin(this.masterService.getNutrients(this.userId, moment(this.fromDate).format('YYYY-MM-DD'), moment(this.toDate).format('YYYY-MM-DD')), this.masterService.getUserProfile(this.userId))
            .subscribe(function (_a) {
            var nutrients = _a[0], user = _a[1];
            _this.nutrients = nutrients;
            _this.user = user;
            _this.changeDetectorRef.markForCheck();
            _this.appLoadingEventsEmitter.broadcastAppIsLoading(false);
        });
    };
    NutrientsComponent.prototype.getMonday = function (date) {
        return new Date(date.setDate((date.getDate() - date.getDay() + (date.getDay() === 0 ? -6 : 1))));
    };
    NutrientsComponent.prototype.openMessages = function (profile) {
        this.router.navigate(['/master/messages', profile.id]);
    };
    NutrientsComponent.prototype.openUserMeals = function (profile) {
        var _this = this;
        this.masterService.masterLogin(profile.id).subscribe(function (token) {
            _this.authService.setStorageItem('original_logged_token', _this.authService.getJWT());
            _this.authService.setStorageItem('master_sub_profile_logged_token', token.token);
            // this.authService.setJWT(this.authService.getStorageItem('master_sub_profile_logged_token'));
            _this.router.navigate(['/master/meals', profile.id]);
        });
    };
    return NutrientsComponent;
}());
export { NutrientsComponent };
